

/// <reference path="Tag.ts" />

// Generated class TipPoolTag_ManagedObject

class TipPoolTag_ManagedObject extends Tag
{

    // Property: tipPoolFormat
    set tipPoolFormat(value:string) {
        this.setValueForKey(value, 'tipPoolFormat');
    }
    get tipPoolFormat():string {
        return this.valueForKey('tipPoolFormat');
    }
    set tipPoolFormatPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'tipPoolFormat');
    }
    get tipPoolFormatPrimitiveValue():string {
        return this.primitiveValueForKey('tipPoolFormat');
    }
}
